import {
  ROLELIST,
} from 'actions/role';
import {reducerPackage} from "../../utils";

export const roleList = reducerPackage(ROLELIST);
